import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type LlmCall = WithLegacy<{
  id: string | null;
  pipelineRunId: string | null;
  contentSourceId: string | null;
  purpose: string | null;
  provider: string | null;
  model: string | null;
  requestedModel: string | null;
  promptHash: string | null;
  promptVersion: string | null;
  inputTokens: number | null;
  outputTokens: number | null;
  cacheReadTokens: number | null;
  cacheWriteTokens: number | null;
  durationMs: number | null;
  finishReason: string | null;
  temperature: number | null;
  status: string | null;
  errorMessage: string | null;
  cachedContentName: string | null;
  transcript: string | null;
  createdAt: string | null;
  [Type]: 'llm-calls';
}>;

export const LlmCallSchema = withDefaults({
  type: 'llm-calls',
  fields: [
    { name: 'id', kind: 'attribute', type: 'string' },
    { name: 'pipelineRunId', kind: 'attribute', type: 'string' },
    { name: 'contentSourceId', kind: 'attribute', type: 'string' },
    { name: 'purpose', kind: 'attribute', type: 'string' },
    { name: 'provider', kind: 'attribute', type: 'string' },
    { name: 'model', kind: 'attribute', type: 'string' },
    { name: 'requestedModel', kind: 'attribute', type: 'string' },
    { name: 'promptHash', kind: 'attribute', type: 'string' },
    { name: 'promptVersion', kind: 'attribute', type: 'string' },
    { name: 'inputTokens', kind: 'attribute', type: 'number' },
    { name: 'outputTokens', kind: 'attribute', type: 'number' },
    { name: 'cacheReadTokens', kind: 'attribute', type: 'number' },
    { name: 'cacheWriteTokens', kind: 'attribute', type: 'number' },
    { name: 'durationMs', kind: 'attribute', type: 'number' },
    { name: 'finishReason', kind: 'attribute', type: 'string' },
    { name: 'temperature', kind: 'attribute', type: 'number' },
    { name: 'status', kind: 'attribute', type: 'string' },
    { name: 'errorMessage', kind: 'attribute', type: 'string' },
    { name: 'cachedContentName', kind: 'attribute', type: 'string' },
    { name: 'transcript', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
  ],
});
